import { render, staticRenderFns } from "./DotBar.vue?vue&type=template&id=8d7ec2d4&scoped=true&"
import script from "./DotBar.vue?vue&type=script&lang=js&"
export * from "./DotBar.vue?vue&type=script&lang=js&"
import style0 from "./DotBar.vue?vue&type=style&index=0&id=8d7ec2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7ec2d4",
  null
  
)

export default component.exports